import {
  Button,
  Col,
  Container,
  Dropdown,
  FloatingLabel,
  Form,
  Modal,
  Placeholder,
  Row,
} from "react-bootstrap";
import PessoaCadastroCode from "./PessoaCadastro.Code";
import {
  DropdownFilter,
  FloatInput,
  FloatSelect,
  HeadPage,
} from "src/componentes";
import { MunicipioDto } from "../../Municipio/Municipio.Dto";
import { ConsultaMunicipioModule } from "src/hook/Consulta/ConsultaMunicipio.Module";
import { PessoaCadastroProps } from "./PessoaCadastro.Dto";

const PessoaCadastroView = (props: PessoaCadastroProps) => {
  const code = PessoaCadastroCode(props);

  const consultaMunicipio = ConsultaMunicipioModule();

  return (
    <Container>
      <Modal show={code.show} onHide={code.handleClose}>
        <Form
          noValidate
          onSubmit={code.consultaForm.handleSubmit(code.onSubmitConsulta)}
        >
          <Modal.Header closeButton>
            <Modal.Title>Consulta Cadastro</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col xs={12}>
                <FloatInput
                  label="CNPJ"
                  errorsMessage={code.consultaForm.formState.errors.cnpj}
                  registerField={code.consultaForm.register("cnpj")}
                  inputMask="cnpj"
                />
              </Col>
              <Col xs={12}>
                <FloatInput
                  label="UF"
                  errorsMessage={code.consultaForm.formState.errors.uf}
                  registerField={code.consultaForm.register("uf")}
                  maxLength={2}
                  inputMask="maiusculas"
                />
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="default" onClick={code.handleClose}>
              Fechar
            </Button>
            <Button variant="primary" type="submit">
              Enviar
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      <Form noValidate onSubmit={code.form.handleSubmit(code.onSubmit)}>
        <HeadPage headText="Cadastro Pessoa" onBack={props.onCancel}>
          <Dropdown.Item as={Button} onClick={code.handleShow}>
            Importar...
          </Dropdown.Item>
        </HeadPage>

        {!code.loading ? (
          <>
            <Row>
              <Col xs={12} sm={6} md={6} lg={6}>
                <FloatInput
                  label="Nome"
                  errorsMessage={code.form.formState.errors.nome}
                  registerField={code.form.register("nome")}
                  inputMask="capitalizar"
                />
              </Col>
              <Col xs={12} sm={6} md={6} lg={6}>
                <FloatInput
                  label="Nome Fantasia"
                  errorsMessage={code.form.formState.errors.nomeFantasia}
                  registerField={code.form.register("nomeFantasia")}
                  inputMask="capitalizar"
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <FloatInput
                  label="Apelido"
                  errorsMessage={code.form.formState.errors.apelido}
                  registerField={code.form.register("apelido")}
                  inputMask="capitalizar"
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={6} md={6} lg={6}>
                <FloatInput
                  label="CNPJ/CPF"
                  errorsMessage={code.form.formState.errors.documento}
                  registerField={code.form.register("documento")}
                  inputMask="cnpj-cpf"
                />
              </Col>
              <Col xs={12} sm={3} md={3} lg={3}>
                <FloatSelect
                  label="Indicador IE"
                  options={[
                    { label: "Selecione" },
                    { value: "1", label: "Contribuinte" },
                    { value: "2", label: "Contribuinte Isento" },
                    { value: "9", label: "Não Contribuinte" },
                  ]}
                  register={code.form.register("indicadorInscricaoEstadual")}
                  errorsMessage={
                    code.form.formState.errors.indicadorInscricaoEstadual
                  }
                />
              </Col>
              <Col xs={12} sm={3} md={3} lg={3}>
                <FloatInput
                  label="Inscrição Estadual"
                  errorsMessage={code.form.formState.errors.inscricaoEstadual}
                  registerField={code.form.register("inscricaoEstadual")}
                  inputMask="text"
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={3} md={3} lg={3}>
                <FloatInput
                  label="CEP"
                  errorsMessage={code.form.formState.errors.cep}
                  onInputChange={(value: string) => {
                    code.buscarCep(value);
                  }}
                  registerField={code.form.register("cep")}
                  inputMask="cep"
                />
              </Col>
              <Col xs={12} sm={9} md={9} lg={9}>
                <FloatInput
                  label="Bairro"
                  errorsMessage={code.form.formState.errors.bairro}
                  registerField={code.form.register("bairro")}
                  inputMask="capitalizar"
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={8} md={9} lg={9}>
                <FloatInput
                  label="Endereço"
                  errorsMessage={code.form.formState.errors.endereco}
                  registerField={code.form.register("endereco")}
                  inputMask="capitalizar"
                />
              </Col>
              <Col xs={12} sm={4} md={3} lg={3}>
                <FloatInput
                  label="Número"
                  errorsMessage={code.form.formState.errors.enderecoNumero}
                  registerField={code.form.register("enderecoNumero")}
                  inputMask="maiusculas"
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <FloatInput
                  label="Endereço Complemento"
                  errorsMessage={code.form.formState.errors.enderecoComplemento}
                  registerField={code.form.register("enderecoComplemento")}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={10} md={10} lg={10}>
                <DropdownFilter<MunicipioDto>
                  fetchData={consultaMunicipio.MunicipioBuscar}
                  loading={consultaMunicipio.loading}
                  labelDescription="Município"
                  getDescription={(item: MunicipioDto) => item.nomeMunicipio}
                  getId={(item: MunicipioDto) => item.codigoMunicipio}
                  registeredFields={{
                    id: code.form.register("codigoMunicipio"),
                    description: code.form.register("nomeMunicipio"),
                  }}
                  errorsMessageDescription={
                    code.form.formState.errors.codigoMunicipio
                  }
                  onSelect={(item: MunicipioDto | undefined) => {
                    if (item !== undefined) {
                      code.form.setValue(
                        "codigoMunicipio",
                        item.codigoMunicipio?.toString()
                      );
                      code.form.setValue("nomeMunicipio", item.nomeMunicipio);
                      code.form.setValue("uf", item.ufMunicipio);
                    } else {
                      code.form.setValue("codigoMunicipio", "");
                    }
                  }}
                ></DropdownFilter>
              </Col>
              <Col xs={12} sm={2} md={2} lg={2}>
                <FloatInput
                  label="UF"
                  errorsMessage={code.form.formState.errors.uf}
                  registerField={code.form.register("uf")}
                  inputMask="maiusculas"
                  maxLength={2}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <FloatSelect
                  label="Perfil"
                  options={[
                    { label: "Selecione" },
                    { value: "1", label: "Cliente" },
                    { value: "2", label: "Fornecedor" },
                    { value: "3", label: "Cliente e Fornecedor" },
                  ]}
                  register={code.form.register("perfilPessoa")}
                  errorsMessage={code.form.formState.errors.perfilPessoa}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} className="d-grid mt-3 mb-5">
                <Button type="submit">Confirmar</Button>
              </Col>
            </Row>
          </>
        ) : (
          <Placeholder as={FloatingLabel} animation="glow">
            <Placeholder xs={12} />
          </Placeholder>
        )}
      </Form>
    </Container>
  );
};
export default PessoaCadastroView;
